import React, { useState } from "react";
import '../../components/ForgetEmail/ForgetEmail.css';
import { RxCross2 } from "react-icons/rx";
import { MdOutlineMailOutline } from "react-icons/md";
import NewPassword from "../NewPassword/NewPassword";
import { verifyOtp, forgetPasswords } from "../../API/Api"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ForgetEmail = ({ isOpen, onClose, email, userType }) => {
    const [isForgetEmailOpen, setIsForgetEmailOpen] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isResending, setIsResending] = useState(false);
    const [token, setToken] = useState(null);

    const handleSubmitClick = async () => {
        const otpString = otp.join("");

        if (otpString.length !== 6) {
            setErrors({ otp: "Please enter a valid 6-digit OTP." });
            return;
        }

        setIsLoading(true);
        setErrors({});

        try {
            const response = await verifyOtp(email, userType, otpString);
            
            if (response.status) {
                setIsForgetEmailOpen(true);
                setToken(response.token);
            } else {
                if (response.message) {
                    toast.error(response.message, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            }
        } catch (error) {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            } else if (error.message) {
                toast.error(error.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendCode = async () => {
        setIsResending(true);
        try {
            const response = await forgetPasswords(email, userType);
            
            if (response.status) {
                toast.success("New OTP sent successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                });
                setOtp(["", "", "", "", "", ""]);
                document.getElementById(`otp-input-0`)?.focus();
            } else {
                if (response.message) {
                    toast.error(response.message, {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            }
        } catch (error) {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            } else if (error.message) {
                toast.error(error.message, {
                    position: "top-right",
                    autoClose: 5000,
                });
            }
        } finally {
            setIsResending(false);
        }
    };

    const handleCloseForgetEmail = () => {
        onClose();
        setIsForgetEmailOpen(false);
    };

    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        setOtp((prevOtp) => {
            const newOtp = [...prevOtp];
            newOtp[index] = value.slice(0, 1);
            return newOtp;
        });

        if (value && index < otp.length - 1) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="forgetEmailOverlay">
            <ToastContainer 
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
            />

            {!isForgetEmailOpen && isOpen && (
                <div className="forgetEmailModal">
                    <div className="circleIconContainer">
                        <MdOutlineMailOutline className="emailIcon" />
                    </div>

                    <div className="headerforgets">
                        <h2 className="forgetTitle">Check your email</h2>
                    </div>
                    <p className="forgetText">
                        We've sent a 6-digit OTP to your email address. Please check your inbox.
                    </p>

                    <div className="otpContainer">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                id={`otp-input-${index}`}
                                type="text"
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleOtpChange(e, index)}
                                className="otpInput"
                            />
                        ))}
                    </div>
                    {errors.otp && <p className="errorText">{errors.otp}</p>}
                    <div className="resendContainer">
                        <p className="resendText" onClick={handleResendCode}>
                            {isResending ? "SENDING..." : "Didn't get the code? Resend Code"}
                        </p>
                    </div>

                    <button 
                        className="loginBtn" 
                        onClick={handleSubmitClick} 
                        disabled={isLoading}
                    >
                        {isLoading ? "VERIFYING..." : "VERIFY"}
                    </button>
                    <button className="closeModalBtn" onClick={onClose}>
                        <RxCross2 />
                    </button>
                </div>
            )}

            {isForgetEmailOpen && (
                <NewPassword
                    isOpen={isForgetEmailOpen}
                    onClose={handleCloseForgetEmail}
                    email={email}
                    userType={userType}
                    token={token}
                />
            )}
        </div>
    );
};

export default ForgetEmail;